import { FactDocumentContent } from '../reference-content/fact-document-content';
import { Drawer } from '@/new/components/drawers/drawer';

interface FactWithDocumentDrawerProps {
  factId: string | null;
  isOpen: boolean;
  onClose: () => void;
}

export function FactWithDocumentDrawer({ factId, isOpen, onClose }: FactWithDocumentDrawerProps) {
  return (
    <Drawer isOpen={isOpen} onClose={onClose} hideCloseButton={true}>
      {factId && <FactDocumentContent factId={factId} onClose={onClose} />}
    </Drawer>
  );
}
